export default {
    data: () => ({
        translations: {
            title: {
                el: "Προβολή Τοποθεσίας - Εκτός Ωραρίου",
                en: "Pin Display - Outside Operating Hours",
                it: "Visualizza posizione Visualizza posizione - Al di fuori dell'orario di apertura"
            },
            info: {
                el: "Εδώ μπορείτε να αλλάξετε την εμφάνιση της τοποθεσίας στο χάρτη για ώρες εκτός ωραρίου των καταστημάτων.",
                en: "Here you can change the display of the pin on the map for hours outside working hours:",
                it: "Qui puoi modificare l'aspetto della posizione sulla mappa per le ore al di fuori degli orari di apertura."
            },
            uploadText: {
                el: "Πατήστε στο κουμπί για να επιλέξετε εικόνα:",
                en: "Press the following button to choose image:",
                it: "Tocca il pulsante per selezionare un'immagine:"
            },
            validationError: {
                el: "Για να συνεχίσετε πρέπει να ανεβάσετε μια νέα εικόνα",
                en: "To continue you must upload a new image",
                it: "Per continuare è necessario caricare una nuova immagine"
            }
        }
    })
};
